import { isRichTextEmpty } from '../../components/RichTextField'
import { IRecordedCoursePageFields } from '../CoursesOnline/interfaces'
import { ICoursePageFields } from './interfaces'

/** O editor "vazio" do Quill (`<p><br></p>`) vai como vazio, para o site não achar que há texto. */
const richText = (html: string) => (isRichTextEmpty(html) ? '' : html)

/** O presencial manda só a parte comum; o gravado manda também bônus, professores e a foto do tutor. */
type TCoursePageContent = ICoursePageFields & Partial<Omit<IRecordedCoursePageFields, keyof ICoursePageFields>>

/**
 * Página do curso no site: a do presencial (ABRA-406) e a do gravado (ABRA-437). Os textos vão
 * sempre, vazios inclusive, para apagar funcionar. As listas levam o marcador `*_provided`:
 * multipart descarta array vazio, e sem ele a API não distingue a lista esvaziada da que não veio
 * (os PUTs de ativo/destaque).
 */
export const appendCoursePageContent = (formData: FormData, data: TCoursePageContent) => {
  formData.append('hero_description', data.hero_description)
  formData.append('hero_video_url', data.hero_video_url.trim())
  formData.append('about', richText(data.about))
  formData.append('prerequisites', richText(data.prerequisites))
  formData.append('age_type', data.age_type)
  formData.append('age_value', data.age_type ? data.age_value : '')

  formData.append('modules_provided', '1')
  data.modules.forEach((module, index) => {
    if (module.id) formData.append(`modules[${index}][id]`, module.id.toString())
    formData.append(`modules[${index}][title]`, module.title)
    formData.append(`modules[${index}][content]`, richText(module.content))
  })

  formData.append('faqs_provided', '1')
  data.faqs.forEach((faq, index) => {
    if (faq.id) formData.append(`faqs[${index}][id]`, faq.id.toString())
    formData.append(`faqs[${index}][question]`, faq.question)
    formData.append(`faqs[${index}][answer]`, faq.answer)
  })

  if (data.bonuses) {
    formData.append('bonuses_provided', '1')
    data.bonuses.forEach((bonus, index) => {
      if (bonus.id) formData.append(`bonuses[${index}][id]`, bonus.id.toString())
      formData.append(`bonuses[${index}][title]`, bonus.title.trim())
      formData.append(`bonuses[${index}][description]`, richText(bonus.description))
    })
  }

  if (data.teacher_ids) {
    formData.append('teacher_ids_provided', '1')
    data.teacher_ids.forEach((teacherId) => formData.append('teacher_ids[]', String(teacherId)))
  }

  // A URL da foto salva não volta: sem arquivo novo nem remoção, a API mantém a que tem.
  if (data.tutor_image instanceof File) {
    formData.append('tutor_image', data.tutor_image)
  } else if (data.remove_tutor_image) {
    formData.append('remove_tutor_image', '1')
  }
}
